import { render, staticRenderFns } from "./ItemXlsUpload.vue?vue&type=template&id=319e922b&scoped=true"
import script from "./ItemXlsUpload.vue?vue&type=script&lang=js"
export * from "./ItemXlsUpload.vue?vue&type=script&lang=js"
import style0 from "./ItemXlsUpload.vue?vue&type=style&index=0&id=319e922b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e922b",
  null
  
)

export default component.exports